export enum Directions {
  Left = 'left',
  Right = 'right',
}
